<!-- Start Lock Screen Area -->
<div class="lock-screen-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="lock-screen-content">
                <div class="row m-0">
                    <div class="col-lg-5 p-0">
                        <div class="image">
                            <img src="assets/img/computer.png" alt="image">
                        </div>
                    </div>

                    <div class="col-lg-7 p-0">
                        <div class="lock-screen-form">
                            <h2>Your Session Is Locked</h2>

                            <form>
                                <div class="form-group">
                                    <input type="email" class="form-control" name="name" placeholder="Email address">
                                    <span class="label-title"><i class='bx bx-envelope'></i></span>
                                </div>

                                <div class="form-group">
                                    <input type="password" class="form-control" name="email" placeholder="Password">
                                    <span class="label-title"><i class='bx bx-lock-alt'></i></span>
                                </div>

                                <button type="submit" class="lock-screen-btn">Unlock</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Lock Screen Area -->